/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";

import { Link, useLocation, useParams } from "react-router-dom";

import client from "@culturehq/client";
import { classnames, Icon, Loader } from "@culturehq/components";

import { useFetch, useInsideIframe, useOrganizationTitle } from "app/hooks";
import { isPlatformSubdomain, Trans } from "app/utils";

import ErrorPage from "components/ErrorPage";
import LandingPageStories from "components/admin/LandingPageStories";
import ShareLinkComponent from "components/common/ShareLinkComponent";

const DEFAULT_COLOR = "#79b17d";

const LandingPageTrendCallout = ({ orgName }) => {
  const { pathname } = useLocation();
  const { prefix, trendId } = useParams();
  const insideIframe = useInsideIframe();
  const { updateSeoTitle } = useOrganizationTitle();
  const organization = orgName.split("-").join(" ");

  const { error, fetching, json: { landingPage, trend } } = useFetch(
    () => client.listOrganizationLandingPages({
      organization: isPlatformSubdomain(organization) ? undefined : organization,
      trendId,
      route: prefix ? `/${prefix}` : ""
    }),
    [organization, prefix]
  );

  useEffect(() => updateSeoTitle(organization), [organization, updateSeoTitle]);

  if (error) {
    return <ErrorPage error={error} />;
  }

  return (
    <div className={classnames("LandingPageCallout", "LandingPageTrendCallout", orgName)}>
      <div className="LandingPageCallout--Preview">
        <div className="Preview">
          <div className="Preview-Header__Image" style={{ backgroundImage: `url(${trend?.imageUrl || landingPage?.headerImageUrl})` }}>
            <div className="Preview-Header__Overlay">
              <h1 className="Preview-Header__Text Preview-Header__FitText hidden-xs" style={{ backgroundImage: `linear-gradient(120deg, ${landingPage?.primaryColor || DEFAULT_COLOR} 0%, ${landingPage?.primaryColor || DEFAULT_COLOR}38 100%)` }}>
                {trend?.question || landingPage?.headerText}
              </h1>
            </div>
            {!insideIframe && landingPage?.organization && (
              <ShareLinkComponent
                link={`https://${orgName.replace(/\s+/g, "-").toLowerCase()}.culturehq.com${pathname || ""}`}
                organizationId={landingPage.organization.id}
                orgName={orgName}
              />
            )}
          </div>
          <div className="Preview-Body row">
            <div className="col-md-1 Preview-LeftColumn view-sec">
              <Link className="back-arrow" to={prefix ? `/${prefix}` : "/"}>
                <Icon icon="arrow-left-c" />
                <Trans>Go Back</Trans>
              </Link>
            </div>
            <div className="col-md-11">
              {fetching ? (
                <Loader loading />
              ) : (
                <>
                  <LandingPageStories
                    insideIframe={insideIframe}
                    isEducational={landingPage.organization.isEducational}
                    organization={organization}
                    organizationId={landingPage.organization.id}
                    orgName={orgName}
                    trendId={trendId}
                    usersIds={landingPage.usersIds}
                  >
                    <h2><Trans>See our stories</Trans></h2>
                  </LandingPageStories>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPageTrendCallout;
